// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPayorRequest {
    static getAttributeTypeMap() {
        return MedicalEligibilityPayorRequest.attributeTypeMap;
    }
}
MedicalEligibilityPayorRequest.discriminator = undefined;
MedicalEligibilityPayorRequest.additionalProperties = false;
MedicalEligibilityPayorRequest.attributeTypeMap = [
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPayorRequest.js.map